import React, { Component } from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';
import Measure from 'react-measure';

import { Container } from 'theme/Grid';
import PhotographySubNav from 'components/navigation/PhotographySubNav';
import { Photos } from 'components/photography/Photos';

class PhotographyPage extends Component {

  constructor(){
    super();
    this.state = { currentImage: 0 };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }

  openLightbox(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true,
    });
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  render() {
    const width = this.state.width;
    return (
      <Container className="photography-page">
        <PhotographySubNav />
        <Measure bounds onResize={(contentRect) => this.setState({ width: contentRect.bounds.width  })}>
          {
            ({ measureRef  }) => {
              if (width < 1 ){
                return <div ref={measureRef}></div>;
              }
              let columns = 1;
              if (width >= 480){
                columns = 2;
              }
              if (width >= 1024){
                columns = 3;
              }
              if (width >= 1824){
                columns = 4;
              }
              return (
                <div ref={measureRef}>
                  <Gallery photos={Photos} columns={columns} onClick={this.openLightbox} />
                  <Lightbox images={Photos}
                    onClose={this.closeLightbox}
                    onClickPrev={this.gotoPrevious}
                    onClickNext={this.gotoNext}
                    currentImage={this.state.currentImage}
                    isOpen={this.state.lightboxIsOpen}
                    showImageCount={false}
                    width={1600} />
                </div>
              );
            }
          }
        </Measure>
      </Container>
    );
  }
}

export default PhotographyPage;



// WEBPACK FOOTER //
// ./src/containers/PhotographyPage.js